

import { request } from "@weapp/utils";
import { mainHost } from "../../utils";

const ETEAMSID = window.ETEAMSID;
const host = mainHost();

//提交意见反馈
export const commitFeedback = (data: any) => {
    const formData = new FormData();
    formData.append('content', data)
    formData.append("eteamsId", window.ETEAMSID)
    formData.append("employeeId", window.TEAMS?.currentUser?.employeeId)
    formData.append("tenantKey", window.TEAMS?.currentTenant?.tenantKey)
    return request({
        url: `/papi/tenantoperation/adviseinfo/advise`,
        method: "post",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data: formData
    });
};
